import { useEffect, useState } from "react";
import { subscribePipelineStages } from "@/lib/firestore/pipeline";
import type { PipelineStage } from "@/types";

export function usePipelineStages(projectId: string | null) {
  const [stages, setStages] = useState<PipelineStage[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setStages([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    return subscribePipelineStages(
      projectId,
      (data) => {
        setStages(data);
        setLoading(false);
        setError(null);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );
  }, [projectId]);

  return { stages, loading, error };
}
